import { DoubleSide, Matrix4, MeshBasicMaterial, PlaneGeometry, PointLight, RingGeometry, Vector2, Vector3, } from "three";
import { SceneGraphNode } from "../internal";
/**
 * A Ring and a inlying Mesh for 3d Cursor
 * @class Cursor Disk
 * @param {number[]} coordinates position of box in lv95 [m]
 * @param {number} size - the sidelength in [m]
 * @extends {SceneGraphNode}
 * @constructor
 */
export class CursorDisk extends SceneGraphNode {
    /**
     * @method constructor
     * @param {number[]} coordinates position of box in lv95 [m]
     * @param {number} size - the sidelength in [m]
     */
    constructor(coordinates, size) {
        super(null);
        this.screencoord = [];
        this.coordinates = coordinates;
        this.size = size;
    }
    init(traversalState) {
        super.init(traversalState);
        const engine = traversalState.scene.engine;
        const material2 = new MeshBasicMaterial({
            opacity: 0.2,
            transparent: true,
            color: 0xffcc00,
            side: DoubleSide,
        });
        const geometry2 = new PlaneGeometry(0.8, 0.8, 36, 36);
        const geometry = new RingGeometry(0.3, 0.4, 36, 8);
        const position = {
            x: this.coordinates[0] - engine.centroid[0],
            y: this.coordinates[1] - engine.centroid[1],
            z: this.coordinates[2] - engine.centroid[2],
        };
        const material = engine.createMaterial("Lambert", {
            color: "#ff0000",
            opacity: 1,
            transparent: true,
            side: DoubleSide,
        });
        this.iMesh = engine.createMesh(geometry, material, position, true);
        this.iMesh.add(engine.createMesh(geometry2, material2, { x: 0, y: 0, z: 0 }, true));
        this.iMesh.children[0].visible = false;
        let light = new PointLight(0xffffff, 1);
        light.position.set(0, 0, 1);
        this.iMesh.add(light);
        light = new PointLight(0xffffff, 1);
        light.position.set(0, 0, -1);
        this.iMesh.add(light);
    }
    /**
     * Changes color to green
     * @method highlight
     */
    highlight() {
        return;
    }
    /**
     * Changes color to red
     * @method unhighlight
     */
    unhighlight() {
        return;
    }
    /**
     * Changes color
     */
    changeColor(rgb) {
        this.iMesh.material.color.setRGB(rgb[0], rgb[1], rgb[2]);
        this.iMesh.children[0].material.color.setRGB(rgb[0], rgb[1], rgb[2]);
    }
    render(traversalState) {
        super.render(traversalState);
        const engine = this.currentTraversalState.scene.engine;
        // Position your mesh
        const position = new Vector3(this.coordinates[0] - engine.centroid[0], this.coordinates[1] - engine.centroid[1], this.coordinates[2] - engine.centroid[2]);
        this.iMesh.position.set(position.x, position.y, position.z);
        this.iMesh.children[0].updateWorldMatrix(true, false);
        this.iMesh.children[0].lookAt(new Vector3(0, 0, 0));
        this.iMesh.children[0].updateWorldMatrix(true, false);
        this.screencoord = [];
        const child = this.iMesh.children[0];
        const geom = child.geometry;
        const posAttr = geom.getAttribute("position");
        const width = traversalState.scene.engine.getContextWidth();
        const height = traversalState.scene.engine.getContextHeight();
        const combinedMatrix = new Matrix4().multiplyMatrices(traversalState.actualSceneCamera.iCamera.projectionMatrix, traversalState.actualSceneCamera.iCamera.matrixWorldInverse);
        combinedMatrix.multiply(this.iMesh.children[0].matrixWorld);
        for (let i = 0; i < posAttr.count; i++) {
            // local -> world (includes parent transforms)
            const v = new Vector3().fromBufferAttribute(posAttr, i);
            v.applyMatrix4(combinedMatrix);
            // NDC -> screen pixels
            const x = (v.x / 2 + 0.5) * width;
            const y = (1 - (v.y / 2 + 0.5)) * height;
            this.screencoord.push(new Vector2(x, y));
        }
    }
}
//# sourceMappingURL=cursordisk.js.map